export const quizStatsStudent = [
    { name: "Capítulo", value: "chapterName", filter: false },
    { name: "Objetivo", value: "learningObjectiveName", filter: false },
    { name: "Nota", value: "quizStudentPercentage", filter: false },
    { name: "Média dos outros alunos", value: "quizPercentage", filter: false },
    { name: "Status", value: "quizStudentStatus", filter: false },
  ];